module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/step-base-information/step-base-information.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/step-base-information/step-base-information.component.scss
// module chunks = main